import IcSafePayments from './IcSafePayments'
export default IcSafePayments
